import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, FileInput, Separator, Text} from '../../../ui';
import css from '../styles/BecomeCreatorPopupLayout.module.css';

const PDF_FORMAT = 'application/pdf';

const getValidationSchema = (t) => {
  return Yup.object().shape({
    medical_identificator_file: Yup.string().required(
      t('validation.field-req')
    ),
  });
};

const BecomeCreatorPopupLayout = ({
  onSubmitClick,
  onCancelClick,
  initialDocument,
  initialDocumentType,
  isLoading,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.popup}>
      <div className={css.heading}>
        <Text
          color={Text.COLOR.PRIMARY}
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'profile.upload-your-medical-id'} />
        </Text>
      </div>
      <Formik
        initialValues={{
          medical_identificator_file: '',
        }}
        onSubmit={onSubmitClick}
        validationSchema={getValidationSchema(t)}
      >
        {({values}) => (
          <Form>
            <>
              <div className={css.topForm}>
                <FileInput
                  placeholder={t('profile.upload-verification-file')}
                  name={'medical_identificator_file'}
                  allowedFileTypes={'.pdf,image/jpeg,image/png'}
                />
                {!values.medical_identificator_file &&
                  initialDocument &&
                  (initialDocumentType !== PDF_FORMAT ? (
                    <img
                      className={css.embeddedFile}
                      src={`${getRootServerUrl()}/${initialDocument}`}
                      width="400"
                    />
                  ) : (
                    <embed
                      className={css.embeddedFile}
                      src={`${getRootServerUrl()}/${initialDocument}`}
                      width="400"
                      height="300"
                      type={PDF_FORMAT}
                    />
                  ))}
              </div>
              <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
              <div className={css.bottomForm}>
                <div className={css.cancelPseudoButton} onClick={onCancelClick}>
                  <Text
                    color={Text.COLOR.GREY}
                    fontWeight={Text.FONT_WEIGHT.MEDIUM}
                    fontSize={Text.FONT_SIZE.SIZE_16}
                  >
                    <TextLocal id={'create-course.cancel'} />
                  </Text>
                </div>
                <Button
                  color={Button.COLOR.PRIMARY}
                  height={Button.HEIGHT.REGULAR}
                  type={Button.TYPES.SUBMIT}
                  isLoading={isLoading}
                >
                  <TextLocal id={'profile.save'} />
                </Button>
              </div>
            </>
          </Form>
        )}
      </Formik>
    </div>
  );
};

BecomeCreatorPopupLayout.propTypes = {
  onSubmitClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  initialDocument: PropTypes.string.isRequired,
  initialDocumentType: PropTypes.string.isRequired,
  initialDocumentId: PropTypes.string.isRequired,
};

export default BecomeCreatorPopupLayout;
